import $ from 'jquery';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const styles = ({
  root: {
    flexGrow: 1,
    textAlign: 'right',
    backgroundColor: 'inherit !important'
  },
  dot: {
    fontSize: 'large', 
    display: 'inline-block', 
    margin: '0px 10px 0px 5px'
  }
});

class StatusView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      connectionStatusColor: "black",
      serviceStatusColor: "black"
    };
  }

  componentDidMount() {
    const {qtEngine, engine} = this.props;   
    const self =this;
    const initialTimeOut = 3000;
    let connectionTimeOut = initialTimeOut;
    setInterval(() => {
      if (!navigator.onLine) {
        self.setState({
          connectionStatusColor: "red",
          serviceStatusColor: "red"
        });
        return;
      }

      const startTime = new Date().getTime();
      
      const settings = {
        url: `/user_account/user_info?engine=${qtEngine || engine}`,
        timeout: connectionTimeOut,
      };

      $.ajax(settings).done((response) => {
        const requestTime = new Date().getTime() - startTime;   
        if (!response.server) {
            self.setState({ serviceStatusColor: "blue" });
        } else if (response.server.for_guests) {
            self.setState({ serviceStatusColor: "orange" });
        } else {
            self.setState({ serviceStatusColor: "green" });
        }   
        if (requestTime > 1500) {
            self.setState({ connectionStatusColor: "orange" });
        } else {
            self.setState({ connectionStatusColor: "green" });
        }   
      }).always((jqXHR, textStatus) => {
        if (textStatus === "success") {
            connectionTimeOut = initialTimeOut;
        } else if (textStatus === "timeout" && navigator.onLine) {
            self.setState({ connectionStatusColor: "orange" });
            connectionTimeOut += 2000;
        } else {
            self.setState({ serviceStatusColor: "red" });
            connectionTimeOut = initialTimeOut;     
            if (navigator.onLine) {
                self.setState({ connectionStatusColor: "orange" });
            } else {
                self.setState({ connectionStatusColor: "red" });
            }
        }
      }); 
    }, 2000);
  }

  render() {
    const { classes } = this.props;
    const { connectionStatusColor, serviceStatusColor } = this.state;
    return (
      <Grid container className={classes.root} spacing={0}>
        <Grid item xs={6} md={12}>
          <Typography variant="body1" gutterBottom align="right" style={{color: 'black', fontSize: "12px", margin: 0}}>
            Connection
            <strong className={classes.dot} style={{color: connectionStatusColor}}>{String.fromCharCode(0x25CF)}</strong>
          </Typography>
        </Grid>
        <Grid item xs={6} md={12}>
          <Typography variant="body1" gutterBottom align="right" style={{color: 'black', fontSize: "12px", margin: 0}}>
            Service
            <strong  className={classes.dot} style={{color: serviceStatusColor}}>{String.fromCharCode(0x25CF)}</strong>
          </Typography>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(StatusView);
